import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { BrandService } from '../proxy/general/controllers/brand.service';
import { ModelService } from '../proxy/general/controllers/model.service';
import { TractorAttachmentTypeService } from '../proxy/general/controllers/tractor-attachment-type.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';

FieldBuilder.setNamespace('General');

export const TRACTORATTACHMENT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.TractorAttachment.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('hasTag', 'Entity.TractorAttachment.HasTag')
    .build(),
  FieldBuilder
    .foreignKey('brandId', 'Entity.Brand', BrandService)
    .displayFromNested('brand.name')
    .sortBy('brand.name')
    .build(),
  FieldBuilder
    .foreignKey('modelId', 'Entity.Model', ModelService)
    .displayFromNested('model.name')
    .sortBy('model.name')
    .build(),
  FieldBuilder
    .foreignKey('tractorAttachmentTypeId', 'Entity.TractorAttachmentType', TractorAttachmentTypeService)
    .required()
    .displayFromNested('tractorAttachmentType.name')
    .sortBy('tractorAttachmentType.name')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
];

export const TRACTORATTACHMENT_CONFIG = {
  entityName: 'TractorAttachment',
  localizationKey: 'General::Entity.TractorAttachment',
  fields: TRACTORATTACHMENT_FIELDS,
  permission: 'GeneralMachinesAndVehicles.TractorAttachments',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
};
